import { useState, useContext, useEffect } from "react"
import { Button } from "../common/button/Button"
import { Input } from "../common/input/Input"
import { useHistory, useLocation } from "react-router-dom"
import { AppContext, AppContextInterface } from "../../state/ContextProvider"
import { checkPath } from "../../utils/validation-utils"

interface MileageProps {
  text: string
  shouldRenderButton: boolean
  mileage: string
}

const Mileage: React.FC<MileageProps> = ({
  text,
  shouldRenderButton,
  mileage,
}) => {

  const history = useHistory()
  const { search } = useLocation()

  const {
    actions: { addMileage },
  } = useContext(AppContext) as AppContextInterface

  const [mileageError, setMileageError] = useState(false)

  const addCommas = (num: string) =>
    num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")

  const validMileage = () => {
    !mileageError && history.push(`/vehicle-details${checkPath(search)}`)
  }

  const removeNonNumeric = (num: string) => num.toString().replace(/[^\d]/g, "")

  const handleChange = async (e: any) => {
    addMileage(addCommas(removeNonNumeric(e.target.value)))
  }

  useEffect(() => {
    const validate = () => {
      const mileageWithoutCommas = mileage.replace(/[, ]+/g, "").trim()
      const mileageToNumber = parseInt(mileageWithoutCommas)
      if (mileageToNumber >= 1000 && mileageToNumber <= 150999) {
        setMileageError(false)
      } else {
        setMileageError(true)
      }
    }
    if (mileage) {
      validate()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mileage])

  return (
    <div className="mileage-container">
      <p className="mileage-input-text">{text}</p>
      <Input
        name="mileage"
        className="mileage-input"
        placeholder="Enter your mileage"
        type="text"
        value={mileage}
        onChange={handleChange}
      />
      {mileageError && (
        <p className="mileage-error">
          Please enter a mileage between 1000 and 150,999
        </p>
      )}
      {shouldRenderButton && (
        <Button
          variant="blue"
          disabled={mileage ? false : true}
          onClick={validMileage}
        >
          CONTINUE
        </Button>
      )}
    </div>
  )
}

export { Mileage }
